import PieChart from "../Charts/PieChart";

const DashboardZoneCharts = ({ dashBoardSummary, loading }) => {
    const findColorPieChart = (key) => {
        switch (key) {
            case 'Extraordinario':
                return '#df6adb';
            case 'Manual':
                return '#5e74f4';
            case 'Mensual':
                return '#34b4db';
            default:
                return '#000000';
        }
    }

    if (!dashBoardSummary?.ordersCountByZone) return null;

    return (
        <>
            <h3 className="text-center my-5">
                Gráficos por zona
            </h3>
            <div className="row mb-5 justify-content-center">
                {
                    Object.keys(dashBoardSummary?.ordersCountByZone).length > 0 && !loading ?
                        Object.keys(dashBoardSummary?.ordersCountByZone).map((key, i) => {
                            const { zone, ...rest } = dashBoardSummary?.ordersCountByZone[key]
                            return (
                                <div className="col-md-4" key={i}>
                                    <PieChart
                                        title={key.toUpperCase()}
                                        labels={Object.keys(rest).map((key2) => key2)}
                                        defaultSeries={Object.keys(rest).map((key2) => rest[key2])}
                                        colors={Object.keys(rest).map((key2) => findColorPieChart(key2))}
                                    />
                                </div>
                            )
                        })
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }

            </div>
        </>
    );
};

export default DashboardZoneCharts;
